import { initBurgerMenu } from './modules/burger.js';
import { initTabs } from './modules/tabs.js';
import boxesCounter from './modules/boxesCounter.js';
import modal from './modules/modal.js';
import initCalculator from './modules/calculator.js';
import { initTinyCarousels } from './modules/tinyCarousel.js';
import { initAccordion } from './modules/accordion.js';
import { initPhoneMask } from './modules/phoneMask.js';
import { initCF7Forms } from './modules/cf7Forms.js';
import { initVideoBoxes } from './modules/videoBox.js';

document.addEventListener('DOMContentLoaded', () => {
    initBurgerMenu();
    initTabs();
    boxesCounter();
    modal();
    initCalculator();
    initTinyCarousels('.clients__carousel', [
        {
            itemPerRow: 5,
            autoplay: 2500,
            nav: false,
            controls: false,
            responsive: {
                0: { items: 2 },
                768: { items: 2 },
                1200: { items: 5 },
                1600: { items: 6 },
            },
        },
    ]);
    initTinyCarousels('.reviews__slider', [
        {
            itemPerRow: 4,
            autoplay: 0,
            itemWidth: 10,
            nav: false,
            controls: true,
            controlsPosition: 'bottom',
            controlsContainer: '#custom-control',
            responsive: {
                0: { items: 1, autoHeight: true },
                768: { items: 2 },
                1200: { items: 4 },
            },
        },
    ]);
    initAccordion('.faq');
    initPhoneMask();
    initCF7Forms();
    initVideoBoxes();

    const sections = document.querySelectorAll("section[id]");
    const navLinks = document.querySelectorAll(".nav__list a[href^='#']");

    const observerOptions = {
        root: null,
        rootMargin: "-50% 0px -40% 0px", // точка реакції посередині екрану
        threshold: 0
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute("id");

                // прибираємо підсвітку з усіх
                navLinks.forEach(link => link.classList.remove("active"));

                // підсвічуємо активний
                const activeLink = document.querySelector(`.nav__list a[href="#${id}"]`);
                if (activeLink) {
                    activeLink.classList.add("active");
                }
            }
        });
    }, observerOptions);

    sections.forEach(section => observer.observe(section));

    window.addEventListener('load', () => {
        const firstActive = document.querySelector('.boxes__item.active video');
        if (firstActive) firstActive.play().catch(()=>{});
    });

    const copyBtn = document.querySelector('.modal_pay__copy');
    const textarea = document.getElementById('rekvizyty');

    if (!copyBtn) {
        console.warn('Кнопку .modal_pay__copy не знайдено');
    } else {
        copyBtn.addEventListener('click', () => {
            if (textarea) {
                let text = textarea.textContent.trim()
                    .replace(/\s{2,}/g, '\n')
                    .replace(/\n{2,}/g, '\n');

                navigator.clipboard.writeText(text)
                    .then(() => alert('Реквізити скопійовано!'))
                    .catch(err => {
                        console.error('Помилка копіювання:', err);
                        alert('Не вдалося скопіювати реквізити.');
                    });
            } else {
                alert('Поле з реквізитами не знайдено!');
            }
        });
    }


});